module.exports = __webpack_public_path__ + "static/media/map-marker-stay@2x.6664eae3.png";